import { RootState } from '../../../types';

export const selectOfflineId = (state: RootState) => state.core.offline.id;
